var styles = {"Field":"iaJ0wjsvHCs-","Checkbox":"gIwWXFJen2g-","Label":"NveeEG86N3w-","showCheck":"CGK5JExMhk0-","hideCheck":"CssG8Fo-bVw-","disabled":"TKr3J-6ARFo-"};

export { styles as default };
//# sourceMappingURL=Checkbox.module.css.js.map
